<div
  class="not_found_container flex gap-4 align-items-center justify-content-center w-screen h-screen"
>
  <div class="flex flex-column justify-content-start gap-3 w-4">
    <h3 class="text-5xl text-color font-semibold m-0">PAGE NOT FOUND!</h3>
    <p class="text-color-secondary m-0 line-height-2 text-base">
      The page you are looking for doesn't exist. You may have mistyped the
      address or the page may have moved.
    </p>
    <div class="flex gap-2 align-items-center">
      <svg-icon color="--primary-color" key="arrow-back" class="text-primary text-xl"></svg-icon>
      <a class="no-underline text-primary text-sm" routerLink="/"
        >Go to the homepage</a
      >
    </div>
  </div>
  <div class="flex gap-1 align-items-center justify-content-center">
    <h1 data-text="4" class="font-bold m-0">4</h1>
    <div class="person_background">
      <svg
        width="155"
        height="155"
        viewBox="0 0 496 639"
        fill="none"
        class="person"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M51.7309 495.181L124.742 426.027L75.7869 397.881C75.7869 397.881 37.5769 427.211 51.7309 495.181Z"
          fill="#F99B90"
        />
        <path
          d="M495.95 568.731C446.027 612.268 380.747 638.674 309.261 638.674C273.222 638.674 238.708 631.965 206.992 619.713C203.871 563.869 173.698 456.542 173.698 456.542L126.519 493.8L47.2656 394.707C47.2656 394.707 77.3486 337.607 98.7676 303.578C120.187 269.494 166.846 240.935 166.846 240.935L230.313 212.395C230.313 212.395 285.026 197.811 347.668 197.811C410.257 197.811 450.673 285.316 463.391 340.818C476.056 396.285 435.64 428.79 435.64 428.79L495.95 568.731Z"
          fill="#F3FBFB"
        />
        <path
          d="M73.635 265.727L65.886 183.567C65.886 183.567 59.553 152.946 85.511 139.079C111.468 125.212 116.419 179.782 116.419 179.782L105.871 197.344L111.576 213.399C111.576 213.399 144.422 247.286 115.235 285.926C115.235 285.926 97.333 452.218 78.73 470.821C60.128 489.423 41.238 512.134 21.326 492.222C1.41397 472.31 -2.46102 451.178 2.31098 424.431C7.02898 397.684 73.635 265.727 73.635 265.727Z"
          fill="#FFB6AE"
        />
        <path
          d="M173.535 248.775C173.535 251.448 180.316 292.761 220.14 289.801C259.964 286.841 287.321 259.771 293.564 225.903C295.896 213.202 276.127 218.351 268.108 212.126C254.744 201.757 248.986 184.877 248.986 184.877L173.535 248.775Z"
          fill="#F99B90"
        />
        <path
          d="M260.271 197.828C258.028 204.806 255.373 211.013 252.36 216.449C237.184 244.02 213.576 253.241 199.925 257.654C183.582 263.018 154.468 250.855 140.171 236.558C125.927 222.315 108.419 179.566 107.199 175.656C76.0039 74.6068 139.005 65.0628 139.005 65.0628L237.399 60.6318C237.399 60.6318 246.942 85.5848 254.441 115.633C261.526 144.137 266.782 177.198 260.271 197.828Z"
          fill="#FFB6AE"
        />
        <path
          opacity="0.44"
          d="M260.271 197.828C258.029 204.807 255.374 211.013 252.36 216.449C242.619 210.852 228.753 197.918 228.753 169.324C228.753 130.737 186.686 137.303 189.395 115.759C190.274 108.78 195.369 103.13 201.844 100.403C213.774 95.3799 235.48 90.1779 245.794 112.494C247.05 115.202 251.66 114.126 254.459 115.615C261.527 144.138 266.783 177.199 260.271 197.828Z"
          fill="#F99B90"
        />
        <path
          d="M147.254 130.684C148.33 134.738 160.206 173.002 160.206 173.002C160.206 173.002 153.784 200.968 173.714 198.923"
          fill="#FFB6AE"
        />
        <path
          d="M147.254 130.684C148.33 134.738 160.206 173.002 160.206 173.002C160.206 173.002 153.784 200.968 173.714 198.923"
          stroke="#FF8E81"
          stroke-width="6.6"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M193.46 227.436C187.839 228.314 181.246 226.29 177.164 218.759C177.336 218.706 177.544 218.644 177.784 218.572C178.545 218.347 179.632 218.035 180.937 217.688C183.548 216.994 187.024 216.163 190.495 215.609C193.977 215.054 197.406 214.786 199.945 215.191C201.214 215.394 202.209 215.757 202.878 216.29C203.523 216.805 203.89 217.497 203.89 218.459C203.89 220.498 202.766 222.506 200.868 224.139C198.974 225.768 196.348 226.985 193.46 227.436Z"
          fill="#F99B90"
          stroke="#FF8E81"
        />
        <path
          d="M101.03 159.799C101.03 159.799 89.7458 109.427 116.331 96.744C151.204 80.097 198.527 73.818 216.089 81.639C233.651 89.461 243.015 141.555 243.015 141.555C243.015 141.555 260.81 104.565 281.494 125.231C281.494 125.231 280.041 86.393 270.533 60.633C270.533 60.633 296.67 81.639 288.759 64.992C280.848 48.345 245.257 3.96401 188.535 12.683C188.535 12.683 201.846 0 192.984 0C184.122 0 76.0228 17.903 86.6608 80.061C86.6608 80.043 80.6148 122.163 101.03 159.799Z"
          fill="#162929"
        />
        <path
          d="M198.058 111.651C198.058 111.651 223.602 93.3168 248.968 98.0708C274.333 102.825 303.269 151.367 303.269 151.367L311.197 192.411C311.197 192.411 460.753 333.751 465.632 367.799C470.512 401.846 470.117 422.063 452.286 439.895C434.455 457.726 384.764 432.45 373.014 405.022C363.345 382.455 272.342 210.816 272.342 210.816C272.342 210.816 239.406 203.874 239.406 159.781C239.406 115.687 178.289 147.116 198.058 111.651Z"
          fill="#FFB6AE"
        />
        <path
          d="M143.346 183.567C143.346 183.567 144.404 149.394 179.815 166.525C212.589 182.383 176.353 142.541 176.353 142.541L133.246 150.273L143.346 183.567Z"
          fill="#0E9896"
        />
        <path
          d="M111.447 204.484C133.332 204.484 151.074 186.742 151.074 164.857C151.074 142.972 133.332 125.23 111.447 125.23C89.5623 125.23 71.8203 142.972 71.8203 164.857C71.8203 186.742 89.5623 204.484 111.447 204.484Z"
          fill="#0E9896"
        />
        <path
          d="M144.401 164.858C144.401 165.414 144.401 165.97 144.311 166.49C143.522 183.945 129.081 197.829 111.429 197.829C104.774 197.829 98.6207 195.874 93.4547 192.43C90.9787 190.851 88.7007 188.932 86.7987 186.707C83.8217 183.407 81.5427 179.442 80.1797 175.119C79.3907 172.876 78.9237 170.562 78.6907 168.141C78.5477 167.064 78.5117 166.006 78.5117 164.876C78.5117 146.668 93.2217 131.904 111.429 131.904C115.197 131.904 118.838 132.55 122.193 133.716C125.17 134.703 127.969 136.138 130.48 138.003C136.436 142.201 140.921 148.336 143.002 155.512C143.934 158.436 144.401 161.593 144.401 164.858Z"
          fill="#162929"
        />
        <path
          opacity="0.32"
          d="M144.399 164.858C144.399 165.414 144.399 165.97 144.309 166.49C130.478 173.845 108.073 185.577 93.4531 192.43C90.9771 190.851 88.6991 188.931 86.7971 186.707C94.2061 178.922 104.718 169.199 108.737 165.198C113.203 160.732 95.605 168.14 80.196 175.119C79.407 172.876 78.94 170.562 78.707 168.14C93.614 156.086 113.58 140.479 122.209 133.734C125.186 134.721 127.985 136.156 130.496 138.021C125.007 144.031 117.742 153.018 126.496 148.874C138.371 143.188 116.988 171.369 121.132 171.369C123.733 171.369 135.053 162.239 143.018 155.53C143.932 158.436 144.399 161.593 144.399 164.858Z"
          fill="#F3FBFB"
        />
        <path
          d="M206.47 186.438C228.356 186.438 246.097 168.696 246.097 146.811C246.097 124.926 228.356 107.184 206.47 107.184C184.585 107.184 166.844 124.926 166.844 146.811C166.844 168.696 184.585 186.438 206.47 186.438Z"
          fill="#0E9896"
        />
        <path
          d="M239.424 146.829C239.424 147.385 239.424 147.941 239.335 148.461C238.545 165.915 224.105 179.8 206.453 179.8C199.798 179.8 193.644 177.845 188.478 174.4C186.003 172.822 183.724 170.902 181.823 168.678C178.845 165.377 176.567 161.413 175.203 157.09C174.414 154.847 173.948 152.533 173.715 150.111C173.571 149.035 173.535 147.977 173.535 146.846C173.535 128.639 188.245 113.875 206.453 113.875C210.22 113.875 213.862 114.521 217.216 115.687C220.194 116.673 222.992 118.109 225.504 119.974C231.459 124.172 235.944 130.307 238.025 137.482C238.958 140.389 239.424 143.564 239.424 146.829Z"
          fill="#162929"
        />
        <path
          opacity="0.32"
          d="M239.422 146.829C239.422 147.385 239.422 147.941 239.333 148.461C225.502 155.816 203.097 167.548 188.477 174.401C186.002 172.822 183.722 170.903 181.821 168.678C189.23 160.893 199.742 151.17 203.76 147.17C208.227 142.703 190.629 150.112 175.219 157.09C174.43 154.847 173.964 152.533 173.73 150.112C188.638 138.057 208.603 122.45 217.232 115.705C220.21 116.692 223.009 118.127 225.521 119.992C220.031 126.002 212.765 134.989 221.519 130.845C233.395 125.159 212.012 153.341 216.156 153.341C218.757 153.341 230.077 144.21 238.042 137.501C238.957 140.389 239.422 143.564 239.422 146.829Z"
          fill="#F3FBFB"
        />
      </svg>
    </div>
    <h1 data-text="4" class="font-bold m-0">4</h1>
  </div>
</div>
